import ApiService from '@/services/api.service'

const MainService = {

    getBoxes(Id){
        return ApiService.get(`/MdWebBoxByUsers?UserId=${Id}`);
    }
}

export default MainService;